module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/getting-started/getting-started.component.scss
// module id = ./src/app/getting-started/getting-started.component.scss
// module chunks = main